var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrevTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3963 8.6039C8.25798 8.74221 8.25798 8.96646 8.3963 9.10477L12.8538 13.5622C13.0769 13.7853 13.4584 13.6273 13.4584 13.3118V4.39687C13.4584 4.08134 13.0769 3.92332 12.8538 4.14644L8.3963 8.6039Z",
    fill: "#383838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.37546 8.6039C2.23715 8.74221 2.23715 8.96646 2.37546 9.10477L6.83293 13.5622C7.05604 13.7853 7.43753 13.6273 7.43753 13.3118V4.39687C7.43753 4.08134 7.05604 3.92332 6.83293 4.14644L2.37546 8.6039Z",
    fill: "#383838"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevTime);
export default __webpack_public_path__ + "static/media/prev_time.41bd9c0474a1298e98148469e11636aa.svg";
export { ForwardRef as ReactComponent };